import React from 'react'
import { useSelector } from 'react-redux'
import { MainContent } from '../components'

const DetailAbout = () => {
  const organization = useSelector(state => state.organizations.page_organization_detail_data)

  return (
    <div className="lg:pt-16">
      <MainContent data={organization}/>
    </div>
  )
}

export { DetailAbout }
